import companies from './companies.json';

export default {
  companies,
};
